import { render, staticRenderFns } from "./cardStock.vue?vue&type=template&id=7df49fd4&scoped=true"
import script from "./cardStock.vue?vue&type=script&lang=js"
export * from "./cardStock.vue?vue&type=script&lang=js"
import style0 from "./cardStock.vue?vue&type=style&index=0&id=7df49fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df49fd4",
  null
  
)

export default component.exports